export const ACCESS_TOKEN_KEY = "access_token";
export const EXPIRES_IN_KEY = "expires_in";
export const AUTHORIZATION_HEADER_KEY = "Authorization";
export const MOBILE_KEY = "mobile";
export const FEATURES_STORE_KEY = "featuresStore";
export const BRAND = "brand";
export const RETURN_TO_URL = "returnToUrl";
export const CF_GUIDELINES_ACCEPTED_KEY_PREFIX = "cf-guidelines-accepted:";
export const CF_NOTIFICATION_PROMPT_SEEN_KEY_PREFIX = "cf-notification-prompt-seen:";

export const clearLocalStorage = () => {
  const features = localStorage.getItem(FEATURES_STORE_KEY);
  const brand = localStorage.getItem(BRAND);
  const returnToUrl = localStorage.getItem(RETURN_TO_URL);
  const communityFeedGuidelinesEntries: [string, string][] = [];
  const communityFeedNotificationPromptEntries: [string, string][] = [];

  for (let i = 0; i < localStorage.length; i += 1) {
    const key = localStorage.key(i);

    if (!key) {
      continue;
    }

    if (key.startsWith(CF_GUIDELINES_ACCEPTED_KEY_PREFIX)) {
      const value = localStorage.getItem(key);
      if (value !== null) {
        communityFeedGuidelinesEntries.push([key, value]);
      }
      continue;
    }

    if (key.startsWith(CF_NOTIFICATION_PROMPT_SEEN_KEY_PREFIX)) {
      const value = localStorage.getItem(key);
      if (value !== null) {
        communityFeedNotificationPromptEntries.push([key, value]);
      }
    }
  }

  localStorage.clear();

  if (features) {
    localStorage.setItem(FEATURES_STORE_KEY, features);
  }
  if (brand) {
    localStorage.setItem(BRAND, brand);
  }
  if (returnToUrl) {
    localStorage.setItem(RETURN_TO_URL, returnToUrl);
  }

  communityFeedGuidelinesEntries.forEach(([key, value]) => {
    localStorage.setItem(key, value);
  });

  communityFeedNotificationPromptEntries.forEach(([key, value]) => {
    localStorage.setItem(key, value);
  });
};
